<div class="chip">
  {{displayValue}}
  <span class="closebtn" onclick="this.parentElement.style.display='none'">&times;</span>
</div>
